import script from "./FibonacciTool.vue?vue&type=script&lang=js"
export * from "./FibonacciTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__